import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/web/certik.png'
import _imports_1 from './assets/sidebar/s_home.png'
import _imports_2 from './assets/sidebar/getmoga.png'
import _imports_3 from './assets/sidebar/aricon.png'
import _imports_4 from './assets/web/openlink.png'
import _imports_5 from './assets/sidebar/trade.png'
import _imports_6 from './assets/web/comingsoon.png'
import _imports_7 from './assets/sidebar/community.png'
import _imports_8 from './assets/web/avatar-game.png'


const _withScopeId = n => (_pushScopeId("data-v-6a0f8a2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-header" }
const _hoisted_2 = {
  class: "lt lg:flex-row",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_3 = { class: "w-auto text-white flex flex-row hidden minlg:block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-24" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gt" }, null, -1))
const _hoisted_6 = {
  class: "ism-pc",
  style: {"background":"#161a34"},
  id: "isMobileSidebarOpen"
}
const _hoisted_7 = {
  class: "text-white text-right mr-4 mt-4 text-sm",
  style: {"color":"#6d739d"}
}
const _hoisted_8 = { class: "text-right relative pb-5 flex items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-full",
  style: {"background":"#12152c","height":"19px"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "absolute right-2",
  src: _imports_0
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_1
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base" }, " Home ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_2
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Moga "),
  /*#__PURE__*/_createElementVNode("span", { class: "green-title" }, "●")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_3
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Arcade "),
  /*#__PURE__*/_createElementVNode("img", {
    width: "12",
    src: _imports_4,
    class: "ml-3"
  })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_5
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base" }, " Trade ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, " Wallet ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, " GCoin ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, " GGM ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_2
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full text-sm" }, [
  /*#__PURE__*/_createTextVNode(" Marketplace "),
  /*#__PURE__*/_createElementVNode("img", {
    width: "78",
    src: _imports_6,
    class: ""
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "14.5",
  src: _imports_7
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base" }, " Community ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, [
  /*#__PURE__*/_createTextVNode(" News "),
  /*#__PURE__*/_createElementVNode("img", {
    width: "12",
    src: _imports_4,
    class: "ml-3"
  })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, [
  /*#__PURE__*/_createTextVNode(" Guides "),
  /*#__PURE__*/_createElementVNode("img", {
    width: "12",
    src: _imports_4,
    class: "ml-3"
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-flex justify-between items-center w-full" }, [
  /*#__PURE__*/_createTextVNode(" FAQ "),
  /*#__PURE__*/_createElementVNode("img", {
    width: "12",
    src: _imports_4,
    class: "ml-3"
  })
], -1))
const _hoisted_30 = {
  class: "footer",
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","font-family":"'robotoslab'"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_32 = { style: {"display":"flex","flex-wrap":"wrap","justify-content":"center","align-items":"center"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-item",
  href: "https://galaxy-games-inc.gitbook.io/welcome-to-monster-galaxy-p2e-1/",
  target: "_blank"
}, "Docs", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-item",
  href: "https://discord.com/invite/monstergalaxy",
  target: "_blank"
}, "FAQs", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-item",
  href: "https://galaxy-games-inc.gitbook.io/welcome-to-monster-galaxy-p2e-1/contact-us",
  target: "_blank"
}, "Contact Us", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-item",
  href: "http://gcoin.playmonstergalaxy.com/term.html",
  target: "_blank"
}, "Terms and Conditions ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-item",
  href: "http://gcoin.playmonstergalaxy.com/privacy.html",
  target: "_blank"
}, "Privacy Policy ", -1))
const _hoisted_38 = { class: "custom-footer mobile" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, null, -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"li\" data-v-6a0f8a2f><div class=\"icon\" data-v-6a0f8a2f></div><div class=\"title\" data-v-6a0f8a2f></div></div><div class=\"li\" data-v-6a0f8a2f><div class=\"icon\" data-v-6a0f8a2f></div><div class=\"title\" data-v-6a0f8a2f></div></div><div class=\"li\" data-v-6a0f8a2f><div class=\"icon\" data-v-6a0f8a2f></div><div class=\"title\" data-v-6a0f8a2f></div></div><div class=\"li\" data-v-6a0f8a2f><div class=\"icon\" data-v-6a0f8a2f></div><div class=\"title\" data-v-6a0f8a2f></div></div>", 4)
const _hoisted_46 = { class: "flex justify-center" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-head-icon" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_50 = [
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = { class: "space-y-6" }
const _hoisted_52 = {
  key: 0,
  class: "step1"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "welcome" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "email",
    class: "block mb-2 text-sm font-medium text-white text-center"
  }, "Log in or Register"),
  /*#__PURE__*/_createElementVNode("input", {
    type: "email",
    name: "email",
    id: "email",
    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
    placeholder: "Enter your email address",
    required: ""
  })
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, " We will send a one-time verification code to the email entered above. ", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    style: {"background":"#67E1B8","font-family":"'Jungle Adventurer'","font-size":"20px"},
    class: "rounded-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
  }, "NEXT")
], -1))
const _hoisted_57 = [
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  key: 1,
  class: "step2"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "verify" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "password",
    class: "block mb-2 text-sm font-medium text-white text-center"
  }, "A code has been sent to the email provided."),
  /*#__PURE__*/_createElementVNode("input", {
    type: "password",
    name: "password",
    id: "password",
    placeholder: "••••••••",
    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
    required: ""
  })
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white" }, [
  /*#__PURE__*/_createTextVNode(" Didn’t receive it? "),
  /*#__PURE__*/_createElementVNode("u", { style: {"color":"#16EBE5"} }, "Resend")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    style: {"background":"#67E1B8","font-family":"'Jungle Adventurer'","font-size":"20px"},
    class: "rounded-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
  }, "NEXT")
], -1))
const _hoisted_63 = [
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = { class: "flex justify-center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-white",
  style: {"font-family":"'Jungle Adventurer'"}
}, "Announcement", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-store-wrap custom-modal-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tab" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "tab-item active" }, "Updates"),
    /*#__PURE__*/_createElementVNode("div", { class: "tab-item" }, "Activity")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "form-wrap-store ul mt-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "li" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Title"),
      /*#__PURE__*/_createElementVNode("div", { class: "content" }, "content"),
      /*#__PURE__*/_createElementVNode("div", { class: "date" }, "2022")
    ])
  ])
], -1))
const _hoisted_70 = { class: "flex justify-center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-head-icon" }, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { class: "modal-store-wrap custom-modal-body" }
const _hoisted_76 = {
  key: 0,
  class: "form-wrap-store Community-step1"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px","font-size":"20px"} }, " Join the Community! ", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"font-size":"12px","margin":"12px"}
}, "Enter you email to receive our new player materials and start your journey off right.", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"font-size":"12px","margin":"12px"}
}, "Plus! We’ll also send you a weekly events calendar that includes step-by-step guides and info on how to get thousands of dollars' worth of rewards!", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  name: "email",
  id: "email",
  class: "mb-3 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white",
  placeholder: "Enter your email address",
  required: ""
}, null, -1))
const _hoisted_81 = {
  key: 1,
  class: "form-wrap-store Community-step2",
  style: {}
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_83 = { ref: "buyggmModal" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close modal", -1))
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "avatar",
    style: {"width":"140px","height":"140px","margin":"0 auto 5px","background":"#D9D9D9","box-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","border-radius":"20px","overflow":"hidden"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: "",
      class: "avatar"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text1",
    style: {"font-size":"24px","color":"#FFFFFF","text-shadow":"0 0 4px #CDFFF7, 0 0 20px #16D5FF","text-align":"center"}
  }, "Monster Galaxy P2E!"),
  /*#__PURE__*/_createElementVNode("ul", { class: "my-4 space-y-3 mt-10" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.gate.io/zh/trade/GGM_USDT",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "BUY GGM ON GATE.IO")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.bybit.com/en-US/trade/spot/GGM/USDT",
        target: "_blank",
        class: "flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "flex-1 ml-3 whitespace-nowrap" }, "BUY GGM ON BYBIT")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_marquee = _resolveComponent("marquee")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_couldwallet = _resolveComponent("couldwallet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_layout, { class: "" }, {
      default: _withCtx(() => [
        (_ctx.globalLoading)
          ? (_openBlock(), _createBlock(_component_a_spin, {
              key: 0,
              class: "w-full h-full",
              tip: "Loading...",
              size: "large",
              style: {"position":"fixed","z-index":"999","background":"rgba(0,0,0,.5)","display":"flex","align-items":"center","justify-content":"center"}
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              class: "logo",
              to: "home"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_marquee, {
              content: "📢Ahoy Tamers! Treasure Trove Blindbox Sale is LIVE! Unlock a wealth of wondrous Moga!",
              speed: 3
            }),
            _hoisted_4
          ]),
          _hoisted_5
        ]),
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_layout_sider, {
                class: "hover-sidebar roboto",
                width: "230",
                style: {"background":"#161a34","margin-top":"10px"},
                collapsed: _ctx.collapsed,
                "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
                collapsible: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_7, " Audited by ", 512), [
                    [_vShow, !_ctx.collapsed]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_11, 512), [
                    [_vShow, !_ctx.collapsed]
                  ]),
                  _createVNode(_component_a_menu, {
                    selectedKeys: _ctx.selectedKeys,
                    "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                    openKeys: _ctx.openKeys,
                    "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openKeys) = $event)),
                    mode: "inline",
                    style: { height: '100%', borderRight: 0,},
                    theme: "dark",
                    onClick: _ctx.handleClick,
                    onOpenChange: _ctx.onOpenChange,
                    onSelect: _ctx.handleMenuSelect
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, {
                        key: "/home",
                        path: "home",
                        onTitleClick: _ctx.titleClick
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_12
                        ]),
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["onTitleClick"]),
                      _createVNode(_component_a_menu_item, {
                        external: "1",
                        key: "/salemoga",
                        path: "https://app.playmonstergalaxy.com/salemoga",
                        onTitleClick: _ctx.titleClick,
                        class: "text-base"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["onTitleClick"]),
                      _createVNode(_component_a_menu_item, {
                        external: "1",
                        key: "/arcade",
                        path: "https://arcade.playmonstergalaxy.com",
                        onTitleClick: _ctx.titleClick,
                        class: "text-base"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onTitleClick"]),
                      _createVNode(_component_a_sub_menu, { key: "sub4" }, {
                        icon: _withCtx(() => [
                          _hoisted_18
                        ]),
                        title: _withCtx(() => [
                          _hoisted_19
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            key: "9",
                            path: "https://app.playmonstergalaxy.com/wallet",
                            onTitleClick: _ctx.titleClick,
                            class: "text-base"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"]),
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            key: "10",
                            path: "http://gcoin.playmonstergalaxy.com",
                            onTitleClick: _ctx.titleClick,
                            class: "text-base"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"]),
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            key: "/ggm",
                            path: "https://app.playmonstergalaxy.com/ggm",
                            onTitleClick: _ctx.titleClick,
                            class: "text-base"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        external: "1",
                        key: "/getmoga",
                        path: "",
                        onTitleClick: _ctx.titleClick,
                        class: "text-base"
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_23
                        ]),
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["onTitleClick"]),
                      _createVNode(_component_a_sub_menu, {
                        key: "sub2",
                        path: "test",
                        onTitleClick: _ctx.titleClick
                      }, {
                        icon: _withCtx(() => [
                          _hoisted_25
                        ]),
                        title: _withCtx(() => [
                          _hoisted_26
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            class: "text-base",
                            key: "5",
                            path: "https://medium.com/@monstergalaxy",
                            onTitleClick: _ctx.titleClick
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"]),
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            class: "text-base",
                            key: "6",
                            path: "https://galaxy-games-inc.gitbook.io/welcome-to-monster-galaxy-p2e-1/",
                            onTitleClick: _ctx.titleClick
                          }, {
                            default: _withCtx(() => [
                              _hoisted_28
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"]),
                          _createVNode(_component_a_menu_item, {
                            external: "1",
                            key: "sub6",
                            path: "https://rebrand.ly/MonsterGalaxyDiscord",
                            onTitleClick: _ctx.titleClick,
                            class: "text-base"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          }, 8, ["onTitleClick"])
                        ]),
                        _: 1
                      }, 8, ["onTitleClick"])
                    ]),
                    _: 1
                  }, 8, ["selectedKeys", "openKeys", "onClick", "onOpenChange", "onSelect"])
                ]),
                _: 1
              }, 8, ["collapsed"])
            ]),
            _createVNode(_component_a_layout, {
              style: {"background":"#0f1228"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.infoOpen=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_content, {
                  style: _normalizeStyle({ background: '', padding: '0',margin:0,marginTop:'63px', minHeight: 'calc(100vh - 63px)' })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _createElementVNode("a", {
                          class: "nav-item",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.ggmvisiblehandleOk && _ctx.ggmvisiblehandleOk(...args)))
                        }, "Buy GGM"),
                        _hoisted_36,
                        _hoisted_37
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["style"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", {
        class: "li active",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handfooter && _ctx.handfooter(...args)))
      }, _hoisted_41),
      _hoisted_42
    ]),
    _createElementVNode("div", {
      id: "isMobileSidebarClose",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sideopen()))
    }),
    _createElementVNode("div", {
      id: "rgbalayer",
      class: "rgbalayer",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sideclose()))
    }),
    _createVNode(_component_a_modal, {
      class: "login-modal",
      closable: false,
      visible: _ctx.loginVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.loginVisible) = $event)),
      title: "",
      footer: null,
      style: {"background":"#1B203E","overflow":"hidden","border-radius":"12px","padding-bottom":"0"},
      "dialog-style": "background: #1B203E",
      "body-style": "background: #1B203E"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_50)
        ]),
        _createElementVNode("form", _hoisted_51, [
          (_ctx.loginstep==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_57))
            : (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_63))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      id: "announcementModal",
      class: "announcement-modal",
      closable: false,
      visible: _ctx.announcementVisible,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.announcementVisible) = $event)),
      title: "",
      footer: null,
      style: {"background":"#1B203E","overflow":"hidden","border-radius":"12px","padding-bottom":"0"},
      "dialog-style": "background: #1B203E",
      "body-style": "background: #1B203E"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showannouncementmodal && _ctx.showannouncementmodal(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_68)
        ]),
        _hoisted_69
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      class: "join-modal",
      closable: false,
      visible: _ctx.joinVisible,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.joinVisible) = $event)),
      title: "",
      footer: null,
      style: {"background":"#1B203E","overflow":"hidden","border-radius":"12px","padding-bottom":"0"},
      "dialog-style": "background: #1B203E",
      "body-style": "background: #1B203E"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showjoinmodal && _ctx.showjoinmodal(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_74)
        ]),
        _createElementVNode("div", _hoisted_75, [
          (_ctx.Communitystep==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _hoisted_77,
                _hoisted_78,
                _hoisted_79,
                _hoisted_80,
                _createElementVNode("div", {
                  class: "subscribe",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handcomNext1()))
                }, "SUBSCRIBE"),
                _createTextVNode("lue-500 block w-full p-2.5 dark:bg-gray-600 ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createTextVNode(" Successfully"),
                _hoisted_82,
                _createTextVNode(" Subscribed! ")
              ]))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_83, [
      _createVNode(_component_a_modal, {
        class: "buyggm-modal",
        closable: false,
        visible: _ctx.ggmvisible,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ggmvisible) = $event)),
        title: "",
        footer: null,
        style: {"padding-bottom":"0","background":"#0A0048","overflow":"hidden","border-radius":"12px"},
        "dialog-style": "background: #0A0048",
        "body-style": "background: #0A0048"
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.ggmvisiblehandleClose && _ctx.ggmvisiblehandleClose(...args))),
            type: "button",
            class: "absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white",
            "data-modal-hide": "crypto-modal"
          }, _hoisted_86),
          _hoisted_87
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512),
    _createVNode(_component_couldwallet, {
      onLoging: _ctx.showGlobalLoading,
      onLogined: _ctx.pislogin,
      ref: "childRef",
      key: "childRef",
      id: "childRef"
    }, null, 8, ["onLoging", "onLogined"])
  ], 64))
}